export default __webpack_public_path__ + "static/media/1572.e309dfa7.png";